var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-section"
  }, [_c('company-view-heading', _vm._b({
    attrs: {
      "isLinkEnabled": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_vm._t("actions")];
      },
      proxy: true
    }], null, true)
  }, 'company-view-heading', {
    company: _vm.company
  }, false)), _c('v-divider', {
    staticClass: "border-2 primary my-16 my-lg-20"
  }), _c('company-view-introduction-images', _vm._b({
    staticClass: "mb-16 mb-lg-20"
  }, 'company-view-introduction-images', _vm.introduction, false)), _c('company-view-introduction-content', _vm._b({}, 'company-view-introduction-content', _vm.introduction, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }